import { cn } from '@/lib/utils';

interface SectionDividerProps {
  variant?: 'gradient' | 'wave' | 'dots';
  className?: string;
}

const SectionDivider = ({ variant = 'gradient', className }: SectionDividerProps) => {
  if (variant === 'wave') {
    return (
      <div className={cn("relative w-full overflow-hidden", className)}>
        <svg
          viewBox="0 0 1440 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-12 md:h-16"
          preserveAspectRatio="none"
        >
          <path
            d="M0 30C240 60 480 0 720 30C960 60 1200 0 1440 30V60H0V30Z"
            fill="url(#wave-gradient)"
            fillOpacity="0.05"
          />
          <path
            d="M0 30C240 60 480 0 720 30C960 60 1200 0 1440 30"
            stroke="url(#wave-stroke)"
            strokeWidth="1"
            strokeOpacity="0.2"
          />
          <defs>
            <linearGradient id="wave-gradient" x1="0" y1="0" x2="1440" y2="0">
              <stop offset="0%" stopColor="transparent" />
              <stop offset="50%" stopColor="rgb(59, 130, 246)" />
              <stop offset="100%" stopColor="transparent" />
            </linearGradient>
            <linearGradient id="wave-stroke" x1="0" y1="0" x2="1440" y2="0">
              <stop offset="0%" stopColor="transparent" />
              <stop offset="50%" stopColor="rgb(59, 130, 246)" />
              <stop offset="100%" stopColor="transparent" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    );
  }

  if (variant === 'dots') {
    return (
      <div className={cn("relative py-8 flex items-center justify-center gap-3", className)}>
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={cn(
              "w-1.5 h-1.5 rounded-full transition-all duration-300",
              i === 2
                ? "w-2 h-2 bg-primary-400"
                : "bg-primary-500/30"
            )}
          />
        ))}
      </div>
    );
  }

  // Default: gradient line
  return (
    <div className={cn("relative py-8", className)}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative h-px">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary-500/20 to-transparent" />
        </div>
      </div>
    </div>
  );
};

export { SectionDivider };
